import './style.css'
import { initializeApp } from './app'

// Initialize reliably regardless of script load timing.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeApp()
  })
} else {
  initializeApp()
}
